import { useSelector } from "react-redux";
import { dataConstants } from "services/redux/data/constants";
import Button from "theme/Button";
import i18n from "utils/i18n";
import Translate from "utils/translate";
import _ from "lodash";
import { StyleSheet, View } from "react-native";
import TimeslotIcon from "components/molecules/TimeslotIcon";
import ListItem from "components/atoms/ListItem";
import { useNavigation } from "@react-navigation/native";
import { AppRoutes } from "navigations/app-routes";

const ListItemCredit = ({ item, subtitle = undefined, accessoryRight = undefined, children = undefined }) => {

	const _timeslotKinds = useSelector( state => {
		return state.data[dataConstants.TIMESLOT_KINDS];
	} );

    const timeslotKind = _.find( _timeslotKinds, { guid: item?.timeslot_kind?.guid } )
    const timeslotKindTitle = Translate.field( timeslotKind, 'title' )

    return (
        <ListItem
            title={ i18n.t( 'page.credits.item.name', { amount: item.amount, timeslotKind: timeslotKindTitle } ) }
            subtitle={ subtitle ?? i18n.t( 'page.credits.item.unused', { amount: item.amount_unused } ) }
            accessoryLeft={(
                <View
                    style={ styles.iconContainer }>

                    <TimeslotIcon
                        style={ styles.iconInner }
                        timeslot={{
                            kind: timeslotKind?.kind,
                            sub_kind: timeslotKind?.sub_kind,
                        }}
                    />
                </View>
            )}
            accessoryRight={ accessoryRight }>

            { children }
        </ListItem>
    )
}

const styles = StyleSheet.create({
    iconContainer: {
        width: 40,
        height: 40,
    },
    iconInner: {
        transform: [ {
            scale: 0.6
        } ],
    }
})

export default ListItemCredit;